export enum CartTypes {
	STAY = 'STAY',
	ACTIVITY = 'ACTIVITY',
	MERCHANDISE = 'MERCHANDISE',
	TRANSPORT = 'TRANSPORT',
	INSURANCE_OPTION = 'INSURANCE_OPTION',
	ENVIRONMENT_COMPENSATION = 'ENVIRONMENT_COMPENSATION'
}
